import { connect } from 'pwa-helpers';
import { updateSelectedCountryState, fetchStateOptions, getCountryStateOptions, getCountryStateStatus, updateCountryStateStatus, getCountryStateError, countryHasStates } from './country-state';
import store from "../../store/store";
import { StoreState } from "../../store/store.interface";
import { customElement, property } from 'lit/decorators.js';
import { Select } from '../selector/selector';
import { ActionStatus } from '../../common/constants/action-status';
import { handleApiError } from '../../common/utils/api-utils';

/**
 * Select component to allow user to select a country state option. 
 * Country state options are loaded based value of country code property.
 */
@customElement('mhecomm-country-state-selector')
export class CountryStateSelect extends connect(store)(Select) {

  @property()
  type ='';

  @property()
  countryCode = '';

  constructor() {
    super();
    this.defaultOptionFormValue = "";
    this.defaultOptionDisplayValue= "Choose a state";
    this.loadingDisplayValue = "loading country states";
  }

  protected async updated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(_changedProperties);
    if(_changedProperties.has("countryCode")){
      if(countryHasStates(this.countryCode)){
        store.dispatch(fetchStateOptions({type: this.type, countryCode: this.countryCode}));
      }
      if(this.selectedOption){
        store.dispatch(updateSelectedCountryState({id: this.type, state: this.selectedOption}));
      }
    }
  }

  stateChanged(state: StoreState){
    this.isLoading = getCountryStateStatus(state) ===  ActionStatus.loading;
    if (this.countryCode && getCountryStateStatus(state) === ActionStatus.succeeded){
      this.options = getCountryStateOptions(state);
      if(!this.selectedOption){
        this.resetSelectOption();
      }
      store.dispatch(updateCountryStateStatus(ActionStatus.idle));
    } 
    else if(getCountryStateStatus(state) === ActionStatus.failed){
      store.dispatch(updateCountryStateStatus(ActionStatus.idle));
      handleApiError(getCountryStateError(state));
      this.isLoading = false;
      return;
    }
  }

  protected onSelectOption(){
    store.dispatch(updateSelectedCountryState({id: this.type ? `${this.type}`: this._id, state: this.selectedOption}));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-country-state-selector': CountryStateSelect;
  }
}